import Button from '@atlaskit/button';
import { IconButton } from '@atlaskit/button/new';
import ChevronLeftLargeIcon from '@atlaskit/icon/glyph/chevron-left-large';
import ChevronRightLargeIcon from '@atlaskit/icon/glyph/chevron-right-large';
import { Inline, Text, xcss } from '@atlaskit/primitives';
import dayjs from 'dayjs';
import React from 'react';
import { useIntl } from 'react-intl-next';

import { messages } from '../messages';

const ContainerStyles = xcss({
  position: 'sticky',
  top: 'space.0',
  backgroundColor: 'elevation.surface',
  paddingBlock: 'space.100',
  width: '100%',
  zIndex: 'navigation',
  paddingTop: 'space.0',
});

interface MonthSwitcherProps {
  month: number;
  year: number;
  onMonthChange: (month: number, year: number) => void;
}

const MonthSwitcher: React.FC<MonthSwitcherProps> = ({ month, year, onMonthChange }) => {
  const { formatMessage } = useIntl();

  const handlePrevMonth = () => {
    const newMonth = month === 0 ? 11 : month - 1;
    const newYear = month === 0 ? year - 1 : year;
    onMonthChange(newMonth, newYear);
  };

  const handleNextMonth = () => {
    const newMonth = month === 11 ? 0 : month + 1;
    const newYear = month === 11 ? year + 1 : year;
    onMonthChange(newMonth, newYear);
  };

  const handleToday = () => {
    onMonthChange(dayjs().month(), dayjs().year());
  };

  return (
    <Inline
      testId="month-switcher"
      alignBlock="center"
      space="space.250"
      xcss={ContainerStyles}
    >
      <Text weight="bold">{dayjs().month(month).year(year).format('MMM YYYY')}</Text>
      <Inline space="space.050">
        <IconButton
          onClick={handlePrevMonth}
          icon={ChevronLeftLargeIcon}
          label={formatMessage(messages['calendar.month-switcher.previous'])}
        />
        <Button onClick={handleToday}>
          {formatMessage(messages['calendar.month-switcher.today'])}
        </Button>
        <IconButton
          onClick={handleNextMonth}
          icon={ChevronRightLargeIcon}
          label={formatMessage(messages['calendar.month-switcher.next'])}
        />
      </Inline>
    </Inline>
  );
};

export default MonthSwitcher;
